export default class CarouselObserver {
    constructor(el) {
        this.DOM = { el: el };

        this.initEvents();
    }

    initEvents = () => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                entry.target.classList[entry.intersectionRatio > 0.9 ? 'remove' : 'add']('outside-viewport');
            });
        }, { root: this.DOM.el, threshold: [0.01, 0.1, 0.25, 0.5, 0.75, 0.9, 0.99] });

        this.DOM.el.querySelectorAll('.carousel__slide').forEach((slide) => {
            observer.observe(slide);
        });
    }
}
